import { Navigate } from "react-router-dom";
import { useAppConfig } from "@/appConfig";

// While the analytics flag is off, /analytics and /results send the visitor home
// instead of not-found, because emails already sent (and still being sent by the
// API) link straight to them.
const AnalyticsRoute = ({ children }) => {
  const { flags } = useAppConfig() || {};
  return flags?.analytics ? children : <Navigate to="/" replace />;
};

export default AnalyticsRoute;
